import React, { useState } from "react";
import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import axios from "axios";
import { config, weeklyPlanAPI } from "../../config";

const PlanActionButtons = ({ planId, qsStatus, pmStatus }) => {
  const [status, setStatus] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState(null); // 'approve' | 'decline'
  const [remarks, setRemarks] = useState("");
  const [remarksError, setRemarksError] = useState(false); // Validation error state

  const userData = JSON.parse(localStorage.getItem("user"));
  const userPosition = userData?.position;

  const openConfirmation = (action) => {
    setPendingAction(action);
    setRemarks(""); // Reset remarks
    setRemarksError(false); // Clear error
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setDialogOpen(false);
    setPendingAction(null);
    setRemarks("");
    setRemarksError(false);
  };

  const proceedAction = () => {
    const trimmedRemarks = remarks.trim();

    if (!trimmedRemarks) {
      setRemarksError(true);
      return;
    }

    const newValue = pendingAction === "approve" ? 2 : 3;
    setStatus(newValue);
    closeDialog();

    const data = {
      userPosition,
      planId,
      status: newValue,
      intType: 8,
      remarks: trimmedRemarks,
    };

    const requestConfig = {
      ...config,
      method: "POST",
      url: weeklyPlanAPI,
      data: JSON.stringify(data),
    };

    axios(requestConfig)
      .then((response) => {
        console.log("Status update success:", response.data);
        window.location.reload(); // Reload page after success
      })
      .catch((error) => {
        console.error("Status update error:", error);
      });
  };

  const buttonStyle = (color, filled = false, disabled = false) => ({
    backgroundColor: filled ? color : "white",
    color: filled || disabled ? "white !important" : color,
    border: `1px solid ${color}`,
    "&:hover": {
      backgroundColor: filled ? color : "#f0f0f0",
    },
  });

  const renderButtons = () => {
    if (status === 2) {
      return <Button sx={buttonStyle("green", true)}>Approved</Button>;
    }

    if (status === 3) {
      return <Button sx={buttonStyle("red", true)}>Declined</Button>;
    }

    if (userPosition === 9) {
      if (qsStatus === 1) {
        return (
          <>
            <Button
              onClick={() => openConfirmation("approve")}
              sx={buttonStyle("green")}
            >
              Approve
            </Button>
            <Button
              onClick={() => openConfirmation("decline")}
              sx={buttonStyle("red")}
            >
              Decline
            </Button>
          </>
        );
      } else if (qsStatus === 2) {
        return <Button sx={buttonStyle("green", true)}>Approved</Button>;
      } else if (qsStatus === 3) {
        return <Button sx={buttonStyle("red", true)}>Declined</Button>;
      }
    }

    if (userPosition === 1) {
      if (qsStatus === 1 && pmStatus === 1) {
        return (
          <Button sx={buttonStyle("orange", true, true)}>Pending by QS</Button>
        );
      } else if (qsStatus === 2 && pmStatus === 1) {
        return (
          <>
            <Button
              onClick={() => openConfirmation("approve")}
              sx={buttonStyle("green")}
            >
              Approve
            </Button>
            <Button
              onClick={() => openConfirmation("decline")}
              sx={buttonStyle("red")}
            >
              Decline
            </Button>
          </>
        );
      } else if (qsStatus === 2 && pmStatus === 2) {
        return <Button sx={buttonStyle("green", true)}>Approved</Button>;
      } else if (qsStatus === 2 && pmStatus === 3) {
        return <Button sx={buttonStyle("red", true)}>Declined</Button>;
      } else if (qsStatus === 3) {
        return (
          <Button sx={buttonStyle("gray", true, true)}>Declined by QS</Button>
        );
      }
    }

    return null;
  };

  return (
    <>
      <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
        {renderButtons()}
      </Box>

      <Dialog open={dialogOpen} onClose={closeDialog} fullWidth maxWidth="sm">
        <DialogTitle
          sx={{
            backgroundColor: "#1976d2",
            color: "white",
            textAlign: "center",
            padding: "8px",
            fontSize: "1.1rem",
            marginBottom: 1.5,
          }}
        >
          Remarks
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Type your Remarks"
            multiline
            minRows={3}
            value={remarks}
            onChange={(e) => {
              setRemarks(e.target.value);
              if (remarksError && e.target.value.trim()) {
                setRemarksError(false);
              }
            }}
            placeholder="Enter your remarks here"
            error={remarksError}
            helperText={remarksError ? "Remarks are required" : ""}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button onClick={proceedAction} variant="contained" color="primary">
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PlanActionButtons;
